import { useState, useEffect, useMemo } from 'react';

export const useResponsiveStyles = (configStyles) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const responsiveStyles = useMemo(() => {
    const baseHeaderStyle = configStyles?.headerText || {};
    
    return {
      headerText: isMobile ? {
        ...baseHeaderStyle,
        fontSize: `calc(${baseHeaderStyle.fontSize || '20px'} * 0.85)`,
        top: 'calc(6vh + 14px)',
        padding: '6px 16px',
        maxWidth: '85vw',
      } : baseHeaderStyle,
      
      subtitleText: configStyles?.subtitleText || {},
      
      loaderOverlay: configStyles?.loaderOverlay || {},
      
      passOverlay: configStyles?.passOverlay || {},
    };
  }, [configStyles, isMobile]);

  return {
    ...responsiveStyles,
    isMobile,
  };
};

export default useResponsiveStyles;
